import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsSearch = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M10.3788843,13.0829754H1.3533409c-0.2545557,0-0.4778498,0.2344589-0.4778498,0.5001793v9.0277767
		c0,0.272419,0.2299926,0.5001793,0.5001792,0.5001793h9.0277777c0.272419,0,0.5001774-0.2299919,0.5001774-0.5001793V13.57199
		l-0.0022326-0.0111647C10.8701315,13.3263664,10.6647005,13.0829754,10.3788843,13.0829754z M9.9032698,22.1353168H1.85352
		v-8.0497503h8.0497494V22.1353168z"
        />
        <path
          d="M23.1222763,13.5608234l-0.0000019,0.0000019c-0.0357265-0.2545557-0.2813492-0.47785-0.5225086-0.47785
		l-9.1014633,0.0022326c-0.2299929,0.0379601-0.4019289,0.2523222-0.4019289,0.4979448v9.0277786
		c0,0.272419,0.2299919,0.5001793,0.5001783,0.5001793h9.0277786c0.272419,0,0.5001793-0.2299938,0.5001793-0.5001793v-9.0389433
		L23.1222763,13.5608234z M22.1219177,22.1353168h-8.0497494v-8.0497503h8.0497494V22.1353168z"
        />
        <path
          d="M10.3788862,0.8888889L1.2818866,0.8911213c-0.2344588,0.0334941-0.4063955,0.2344588-0.4063955,0.475616
		v9.0277777c0,0.272419,0.2299926,0.5001793,0.5001792,0.5001793h9.0277777c0.272419,0,0.5001783-0.2299929,0.5001783-0.5001793
		V1.3533401l-0.0022335-0.0111647C10.8656664,1.0831549,10.6401386,0.8888889,10.3788862,0.8888889z M9.9032698,9.916666H1.85352
		V1.8669164h8.0497494V9.916666z"
        />
        <path
          d="M13.571991,10.8946943h9.0277767c0.272419,0,0.5001793-0.2299929,0.5001793-0.5001793V1.3667372
		c0-0.1250441-0.0580559-0.2500882-0.1585388-0.3416395c-0.0960159-0.0870839-0.2188263-0.1362088-0.3416386-0.1362088h-9.0523405
		c-0.2545557,0-0.47785,0.2344587-0.47785,0.5001778v9.0032158C13.0695791,10.6647015,13.299572,10.8946943,13.571991,10.8946943z
		 M14.0721684,1.8669164h8.0497494V9.916666h-8.0497494V1.8669164z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsSearch;
